import React, { useContext, useState } from "react";
import {
  Col,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { tabChange } from "../../Utils/SetDefaultRowData";
import ViewOfferBalanceImpactList from "./ViewOfferBalanceImpactList";
import ViewOfferAttributeDetails from "./ViewOfferAttributeDetails";
import { ViewOfferContext } from "./context";

const ViewOfferUsageList = ({ index, usage, activeTab }) => {
  const { sectionRefs } = useContext(ViewOfferContext);
  const [usageRateTab, setUsageRateTab] = useState("1");
  const usageRef = sectionRefs.current[`recurringUsageRatePlan${index + 1}`];

  return (
    <div
      key={index}
      className="border border-opacity-50 rounded-0 mb-3"
      ref={usageRef}
    >
      <Row
        className={`mb-3 px-3 pt-3 ${
          ""
          // index === usagePlanList?.length - 1 ? "" : "border-bottom"
        }`}
        key={index}
      >
        <Col
          xs={12}
          className="d-flex justify-content-between align-items-center pb-4"
        >
          <h3 className="card-title mb-0">
            Usage Rate Plan {index > 0 ? index + 1 : ""} -{" "}
            {usage?.type == 1 ? "One Time" : "Recurring"}
          </h3>
        </Col>
        <div className="rv-nav d-flex">
          <Nav role="tablist" className="mx-1">
            <NavItem>
              <NavLink
                className={usageRateTab === "1" ? "active" : ""}
                onClick={() => {
                  tabChange("1", usageRateTab, setUsageRateTab);
                }}
              >
                <i className="fas fa-home"></i>
                Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="#"
                className={usageRateTab === "2" ? "active" : ""}
                onClick={() => {
                  tabChange("2", usageRateTab, setUsageRateTab);
                }}
                type="button"
              >
                <i className="far fa-user"></i>
                Balance Impact Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={usageRateTab === "3" ? "active" : ""}
                onClick={() => {
                  tabChange("3", usageRateTab, setUsageRateTab);
                }}
              >
                <i className="fas fa-home"></i>
                Attribute Based Details
              </NavLink>
            </NavItem>
          </Nav>
        </div>
        <TabContent activeTab={usageRateTab}>
          <TabPane tabId={"1"}>
            <Row className="mt-4">
              <Col xs={12} md={6} lg={4} xxl={3}>
                <Label className="fw-bold">Usage Event Type</Label>
                <p>{usage?.eventType ? usage?.eventType?.label : "-"}</p>
              </Col>
              <Col xs={12} md={6} lg={4} xxl={3}>
                <Label className="fw-bold">UOM</Label>
                <p>
                  {usage?.unitOfMeasurement
                    ? usage?.unitOfMeasurement?.label
                    : "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4} xxl={3}>
                <Label className="fw-bold">Priority</Label>
                <p>{usage?.priority ? usage?.priority : "-"}</p>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={"2"}>
            {usage?.balanceImpacts && usage?.balanceImpacts.length > 0 && (
              <Row>
                <ViewOfferBalanceImpactList
                  value={usage?.balanceImpacts}
                  usageType={usage?.type}
                />
              </Row>
            )}
          </TabPane>
          <TabPane tabId={"3"}>
            <ViewOfferAttributeDetails
              attributeBasedList={usage?.attributeBasedDetails}
            />
          </TabPane>
        </TabContent>
      </Row>
    </div>
  );
};

export default ViewOfferUsageList;
